import { useCreateActivity } from "../../../api/activitystreams.ts";
import { useUpdateActivityInCache } from "../../../hooks/activitystreams/useUpdateActivityInCache.ts";
import { omit } from "lodash";
import { Activity, ActivityCreation } from "../../../@types/activities.ts";

type ErrorInteractionsArgs = {
  activity: ActivityCreation | Activity;
  setStoredActivities: (activities: Activity[]) => void;
};

export default function ErrorInteractions({
  activity,
  setStoredActivities,
}: ErrorInteractionsArgs) {
  const { prependActivity } = useUpdateActivityInCache();
  const { id: localId } = activity;

  function removeFromLocalStorage(localId?: string, activityData?: any) {
    const activities = JSON.parse(localStorage.getItem("activities") || "[]");

    let filteredActivities;
    if (localId) {
      filteredActivities = activities.filter(
        (activity: any) => activity.id !== localId,
      );
    } else {
      filteredActivities = activities.filter(
        (activity: any) =>
          JSON.stringify(activity.object?.content) !==
          JSON.stringify(activityData?.object?.content),
      );
    }

    setStoredActivities(filteredActivities);
  }

  const { mutate: createActivity } = useCreateActivity({
    onSuccess: (activity: Activity) => {
      prependActivity(activity);
      removeFromLocalStorage(localId, activity);
    },
    onError: () => {
      toastr.error(I18n.t("js.generic_error"));
    },
  });

  return (
    <div className="flex gap-2 justify-end">
      <button
        role="button"
        className="btn btn-light"
        onClick={(e) => {
          {
            e.preventDefault();
            removeFromLocalStorage(localId, activity);
            toastr.warning(I18n.t("js.activity.activity_discarded"));
          }
        }}
      >
        {I18n.t("js.activity.discard_activity")}
      </button>
      <button
        role="button"
        className="btn btn-primary"
        onClick={(e) => {
          e.preventDefault();
          createActivity(omit(activity as ActivityCreation, "id"));
        }}
      >
        {I18n.t("js.activity.resend_activity")}
      </button>
    </div>
  );
}
